import { defineComponent } from 'vue';
export default defineComponent({
    name: 'FilterList',
    props: {
        taxonomy: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: null,
        },
        terms: {
            type: Array,
            required: true,
        },
        selectedTerms: {
            type: Set,
            required: true,
        },
        toggleCb: {
            type: Function,
            required: false,
        },
        fullOpen: {
            type: Boolean,
            default: false,
        },
        depth: {
            type: Number,
            default: 1,
        },
        maxDepth: {
            type: Number,
            default: null,
        },
    },
    methods: {
        handleChange(e, term) {
            const checked = e.target.checked;
            if (this.toggleCb === undefined)
                return;
            this.toggleCb(this.taxonomy, term, checked);
        },
    },
});
